import { render, staticRenderFns } from "./view-info.vue?vue&type=template&id=5683d1da&scoped=true"
import script from "./view-info.vue?vue&type=script&lang=js"
export * from "./view-info.vue?vue&type=script&lang=js"
import style0 from "./view-info.vue?vue&type=style&index=0&id=5683d1da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683d1da",
  null
  
)

export default component.exports